import { useNavigate } from 'react-router-dom';

type NavigationButton = {
  icon: string;
  title: string;
  path: any; // will be a string or a delta
  className?: string;
  disabled?: boolean;
};

interface PageHeadingProps {
  navigationButtons?: NavigationButton[];
  title?: string;
}

export const PageHeading = ({ navigationButtons, title }: PageHeadingProps) => {
  const navigate = useNavigate();

  const renderNavigationButton = ({ icon, title, path, className, disabled }: NavigationButton) => {
    if (disabled) return null;
    return (
      <div className="flex flex-row cursor-pointer hover:text-secondary-deep-blue-30 pr-4" onClick={() => navigate(path)} key={title}>
        <img src={icon} className={!className ? 'mt-1 mr-1 h-4 w-4' : className} />
        <div className="text-base">{title}</div>
      </div>
    );
  };

  return (
    <div>
      {navigationButtons && <div className="pl-2 py-2 flex flex-row">{navigationButtons.map(renderNavigationButton)}</div>}
      {title && (
        <div className="pt-2 pb-4 pl-1">
          <h1 className="text-2xl font-bold">{title}</h1>
        </div>
      )}
    </div>
  );
};
